export enum StockLayerExpirationAlert {
    EXPIRING_SOON = 'expiring_soon',
    EXPIRED = 'expired',
    NONE = 'none',
}